import { EventEmitter, Injectable } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { HttpClient } from '@angular/common/http';
import { CallRecordingModalComponent } from 'src/app/repository/call-recording-modal/call-recording-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ReportService } from 'src/app/repository/service/report.service';

@Injectable({
  providedIn: 'root'
})
export class CommonGridService {
  public isLoading:boolean = false;
  public agGridData:any = {"columnDefs":[],"rowData":[]};
  public gridData:any = {};
  public showSearchBar:boolean = false;
  public showTotalDataCount:boolean = false;
  public isCellBorder:boolean = false;
  public isCellTextBold:boolean = false;
  public commonGridPlaceHolder
  public gridAllData:any = {};
  public gridFilters:any = {};
  public gridOtherFilters:any = {};
  public gridHeaders:any = {};
  public appliedFilter:any = {};
  public copyappliedFilter:any = {};
  public gridDataContainer:any[] = [];
  public gridResult:any = {};
  public gridDataTotal:any;
  public gridPageTotal:any;
  public startDate:any;
  public endDate:any;
  public page = 1;
  public page_size = 20;
  public serachBy:string = "";
  public bufferArr:any = [];
  public surveyId:number = 12703;
  public sortby:string="";
  public sortOrder:string = "";
  public sortingDeatils:any = {};
  public gridInitFor:string="";
  public studyId:string = "";
  public isCommonGridDataLoaded = new EventEmitter<boolean>();


  constructor(
    private apiRequest:ApiRequestService,
    public notifier: NotifierService,
    private http: HttpClient,
    private dialog:MatDialog,
    public reportService:ReportService
    ) { 
      
    }
  

  initCommonGrid(){
    this.resetAll();
    // this.isLoading = true;
  }

  getDiaryApiResposes(body){
    return this.apiRequest.request('POST','/diary_user_responses',body);
  }

  getDairyDashboardDataDayWise(body,isInit?,isBuffer?){
    this.getDiaryApiResposes(body).subscribe((res:any) =>{
      if(res && res['status'] == 1){
        if(res && res['result']){
          if(isBuffer && res['result']['data']){
            this.bufferArr = res.result.data;
          }else{
            this.isLoading = false;
            if(isInit){
              this.gridFilters = res.result.filters || {};
              if(Object.keys(this.gridFilters).length){
                this.setDate(this.gridFilters);
              }
            }
            if(body?.page == 1){
              this.gridDataContainer = [];
            }
            this.gridResult = res.result;
            this.gridDataContainer = [...this.gridDataContainer,...res.result.data];
            this.gridHeaders = res.result.headers;
            this.gridDataTotal = res.result.total;
            this.gridPageTotal = res.result.total_page;
            this.getPlaceHolderValue(this.gridHeaders);
          }
        }
      }else{
        this.isLoading = false;
        this.resetAll();
        // console.log("Reset app called by getDairyDashboardDataDayWise")
        this.notifier.notify('error',res['message'] || 'Something Went Wrong');
      }
    })
  }

  getDairyDashboardDataCenterWise(body,isInit?,isBuffer?){
    this.getDiaryApiResposes(body).subscribe((res:any) =>{
      if(res && res['status'] == 1){
        if(res && res['result']){
          if(isBuffer && res['result']['data']){
            this.bufferArr = res.result.data;
          }else{
            this.isLoading = false;
            if(isInit){
              this.gridFilters = res.result.filters || {};
              if(Object.keys(this.gridFilters).length){
                this.setDate(this.gridFilters);
              }
            }
            if(body?.page == 1){
              this.gridDataContainer = [];
            }
            this.gridResult = res.result;
            this.gridDataContainer = [...this.gridDataContainer,...res.result.data];
            this.gridHeaders = res.result.headers;
            this.gridDataTotal = res.result.total;
            this.gridPageTotal = res.result.total_page;
            this.getPlaceHolderValue(this.gridHeaders);
          }
        }
      }else{
        this.isLoading = false;
        this.resetAll();
        // console.log("Reset app called by getDairyDashboardDataCenterWise")
        this.notifier.notify('error',res['message'] || 'Something Went Wrong');
      }
    })
  }

  setOtherFilters(){
    this.gridOtherFilters =  {
      "group": {
        "0": {
          "label": "All",
          "key": "group",
          "value": "all",
          "type": "checkbox",
          "selection": "string"
        },
        "1": {
          "label": "Company",
          "key": "group",
          "value": "company"
        },
        "2": {
          "label": "City",
          "key": "group",
          "value": "city"
        },
        "3": {
          "label": "Zone",
          "key": "group",
          "value": "zone"
        }
      },
      "trend": {
        "0": {
          "label": "Week",
          "key": "trend",
          "type": "radio",
          "value": "week"
        },
        "1": {
          "label": "Month",
          "key": "trend",
          "value": "month"
        },
        "2": {
          "label": "Day",
          "key": "trend",
          "value": "day"
        }
      }
    }
  }

  getAutoGridDataApi(body,apiUrl){
    return this.apiRequest.request('POST',apiUrl,body);
  }

  getAutoGridData(body,apiUrl,isInit?,isBuffer?){
    // debugger
    this.getAutoGridDataApi(body,apiUrl).subscribe((res:any) =>{
      if(res && res[0] && res[0]['status'] == 4){
        this.notifier.notify('error',res[0]['message']);
        this.reportService.redirectUnAuthorizedEvent.emit('unauthorized');
      }
      if(res && res['status'] == 1){
        if(res && res['result']){
          if(isBuffer && res['result']['data']){
            this.bufferArr = res.result.data;
          }else{
            this.isLoading = false;
            if(isInit){
              this.gridFilters = res.result.filters || {}
              // this.gridOtherFilters = res.result.other_filters || {};
              // this.setOtherFilters();
              // this.gridOtherFilters = this.setOtherFilters();
              // debugger
              if(Object.keys(this.gridFilters).length){
                this.setDate(this.gridFilters);
              }
            }
            if(body?.page == 1){
              this.gridDataContainer = [];
            }
            this.gridResult = res.result;
            this.gridDataContainer = [...this.gridDataContainer,...res.result.data];
            this.gridHeaders = res.result.headers;
            this.gridDataTotal = res.result.total;
            this.gridPageTotal = res.result.total_page;
            this.isCommonGridDataLoaded.emit(true);
            this.getPlaceHolderValue(this.gridHeaders);
          }
        }
      }else if(res && res['status'] == 4){
        this.reportService.redirectUnAuthorizedEvent.emit('unauthorized');
      }
      else{
        this.isLoading = false;
        this.resetAll();
        // console.log("Reset app called by getDairyDashboardDataCenterWise")
        this.notifier.notify('error',res['message'] || 'Something Went Wrong');
      }
    })
  }

  getPlaceHolderValue(headers){
    this.showSearchBar = false;
    let commonGridPlaceHolder = [];
    Object.keys(headers).forEach(va =>{
      if(headers[va]['isSearch']){
        commonGridPlaceHolder.push(headers[va]['name']);
      }
    })
    if(commonGridPlaceHolder.length){
      this.showSearchBar = true;
      this.commonGridPlaceHolder = 'Search by ' + commonGridPlaceHolder.join(',');
    }
  }

  jsonToCsv(headers,data) {
    const header = Object.keys(headers);
    const csv = [
      header.join(','), // Create the header row
      ...data.map((row) => header.map((fieldName) => row[fieldName]).join(',')),
    ].join('\n');
    return csv;
  }

  jsonToCsvDownload(body,type){
    this.getDiaryApiResposes(body).subscribe((res:any) =>{
      if(res && res['status'] == 1){
        if(res.result.headers && res.result.data.length){
          const csv = this.jsonToCsv(res.result.headers,res.result.data);
          this.downloadCsv(csv,type);
        }
      }else{
        this.isLoading = false;
        this.resetAll();
        // console.log("Reset app called by jsonToCsvDownload")
        this.notifier.notify('error',res['message'] || 'Something Went Wrong');
      }
    })
  }

  jsonToCsvGenerator(data,type){
    if(data.headers && data.data.length){
      const csv = this.jsonToCsv(data.headers,data.data);
      console.log(csv);
      this.downloadCsv(csv,type);
    }
   
  }
  
  downloadCsv(csvData,name) {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = name; // Specify the desired CSV file name
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }
  
  resetAll(){
    this.showSearchBar = false;
    this.showTotalDataCount = false;
    this.gridDataContainer = [];
    this.bufferArr = [];
    this.gridFilters = {};
    this.gridHeaders = {};
    this.appliedFilter = {};
    this.copyappliedFilter = {};
    this.gridDataTotal = 0;
    this.gridPageTotal = 0;
    this.serachBy = "";
    this.page = 1;
    this.page_size = 20;
    // this.surveyId = ((this.studyId === 'a566179a-e9bd-4810-bbc2-29fc89f9f856') ||  (this.studyId === '068e0008-8bf3-4cd4-8cc4-59b78432dc63')) ? 13776 : 15821;
    this.surveyId = ((this.studyId === 'a566179a-e9bd-4810-bbc2-29fc89f9f856') ||  (this.studyId === '068e0008-8bf3-4cd4-8cc4-59b78432dc63')) ? 13776 : 12703;
    // this.surveyId = survey_id ? survey_id : ((this.studyId === 'a566179a-e9bd-4810-bbc2-29fc89f9f856') ||  (this.studyId === '068e0008-8bf3-4cd4-8cc4-59b78432dc63')) ? 13776 : 12703;
    this.startDate = '';
    this.endDate = ''
    this.sortby = "";
    this.sortOrder = "";
    this.sortingDeatils = {};
  }

 
  
  setDate(filter){
    Object.keys(filter).forEach(va =>{
      if(filter[va][0]['type'] == 'calendar'){
        let start_date = filter[va][0]['start_date'];
        let end_date = filter[va][0]['end_date'];
        if(start_date && end_date){
          this.startDate = new Date(start_date);
          this.endDate = new Date(end_date);
        }
        return;
      }
    })
  }

  getCallRecordingData(body,isInit,isBuffer){  
    this.getAutoGridData(body,'/calling_panel_qc_data',isInit,isBuffer);
    // this.getAutoGridDataApi(body,'/calling_panel_qc_data').subscribe((res:any) =>{
    //   if(res && res['status'] == 1){
    //     this.isLoading = false;
    //     this.gridHeaders = res.headers;
    //     this.gridDataContainer = res.data;
    //   }else{
    //     this.isLoading = false;
    //     this.resetAll();
    //     this.notifier.notify('error',res['message'] || 'Something Went Wrong');
    //   }
    // })
  }

  callRecordingS3Link(down_id:string,type:string){
    let urlType;
    if(type == 'recording'){
      urlType = 'download';
    }else{
      urlType = type;
    }
    let body = {};
    body['key'] = down_id;
    this.getAutoGridDataApi(body,`/calling_panel_qc/${urlType}/qc`).subscribe((res:any) =>{
      if(res && res['status'] == 1){
        switch (type) {
          case 'copy':
            this.copyFileUrl(res.url);            
            break;

          case 'download':
              this.getDownload(res.url,down_id);            
              break; 

          case 'recording':
              this.playRecording(res.url);            
              break;
        }


       
      }else{
        this.isLoading = false;
        this.resetAll();
        this.notifier.notify('error',res['message'] || 'Something Went Wrong');
      }
    })

  }


  copyFileUrl(url:any){
    if (navigator.clipboard) {
        navigator.clipboard.writeText(url)
        this.notifier.notify('success','Text successfully copied to clipboard');
    } else {
      this.notifier.notify('error','Clipboard API not supported in this browser');
    }
  }


  playRecording(url:any){
    this.dialog.open(CallRecordingModalComponent,{
      height:'150px',
      width:'600px',
      data:{'url':url}
    })

  }


  getDownload(url:any,id:string){
    let link = document.createElement('a');
    link.href = url;
    link.download = `${id}.mp3`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }




}
